import { EntityType, EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";

export const MAP_ENTITY_TYPES: EntityTypesSupportedByMapsPage[] = [
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
];

// shared so the notification and every path that clears a filter agree on which notice to close
export const HIDDEN_ENTITIES_NOTIFICATION_KEY = "map.savedFilter.hiddenEntities";

export const OTHER_CLUSTER_ZINDEX = 1;
export const OTHER_PIN_ZINDEX = OTHER_CLUSTER_ZINDEX + 1;
export const BASE_CLUSTER_ZINDEX = OTHER_PIN_ZINDEX + 1;
export const PIN_ZINDEX = BASE_CLUSTER_ZINDEX + 100000; // should be higher than any cluster
export const BASE_LEAD_ICON_ZINDEX = PIN_ZINDEX + 1; // higher than regular pin
export const TERRITORY_LABEL_ZINDEX = BASE_LEAD_ICON_ZINDEX + 1; // higher than all pins
export const DEMOGRAPHY_LABEL_ZINDEX = BASE_LEAD_ICON_ZINDEX + 1; // higher than all pins
export const RULER_POINT_LABEL_ZINDEX = BASE_LEAD_ICON_ZINDEX + 1; // higher than all pins
export const USER_LOCATION_ZINDEX = TERRITORY_LABEL_ZINDEX + 1;
export const USER_LOCATION_HISTORY_PATH_ZINDEX = USER_LOCATION_ZINDEX + 1;
// Below the check-in pins and the rep avatars, above the trail: the ring frames a marker rather than
// covering it, and still reads on a bare trail vertex where no marker exists.
export const USER_LOCATION_SELECTION_RING_ZINDEX = USER_LOCATION_HISTORY_PATH_ZINDEX + 1;
export const USER_LOCATION_HISTORY_ZINDEX = USER_LOCATION_SELECTION_RING_ZINDEX + 1;
export const SELECTED_USER_LOCATION_HISTORY_ZINDEX = USER_LOCATION_HISTORY_ZINDEX + 1;
export const DEMOGRAPHY_FEATURE_ZINDEX = SELECTED_USER_LOCATION_HISTORY_ZINDEX + 1;
export const TERRITORY_FEATURE_ZINDEX = DEMOGRAPHY_FEATURE_ZINDEX + 3;
export const LOWER_DECK_OVERLAY_ZINDEX = DEMOGRAPHY_FEATURE_ZINDEX;
export const TERRITORIES_DECK_OVERLAY_ZINDEX = TERRITORY_FEATURE_ZINDEX;
export const UPPER_DECK_OVERLAY_ZINDEX = PIN_ZINDEX + 100; // above the pins, like the ruler overlay
export const ROUTE_FEATURE_ZINDEX = TERRITORY_FEATURE_ZINDEX + 1;
export const ROUTE_LABEL_ZINDEX = ROUTE_FEATURE_ZINDEX + 1;
export const LASSO_ZINDEX = ROUTE_LABEL_ZINDEX + 1; // higher than all other map features and demography feature
export const AREA_REGION_ZINDEX = LASSO_ZINDEX + 1;
export const AREA_REGION_UNITED_REGION = AREA_REGION_ZINDEX + 1;
export const FOCUSED_ENTITY_ZINDEX = AREA_REGION_UNITED_REGION + 1;
export const BASE_TOOLTIP_ZINDEX = FOCUSED_ENTITY_ZINDEX + 1; // higher than all pins and labels

export const BASE_CLUSTER_FILL_OPACITY = 0.85;
export const MIN_LEGEND_HEIGHT = 360; // 22.5rem
export const OTHER_CLUSTER_FILL_OPACITY = 0.5;
